import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { LanguagesService } from './services/language.service';
import { TimerService } from './services/timer.service';

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html"
})
export class AppComponent {
  title = 'returning';
  isWide = false;
  constructor (private router: Router,
    public langService: LanguagesService,
    private timerService: TimerService,
  ) {
      
  }
  public antiTimeOut() { //cancel popup confirmation dialog to logout in case a mouse clicking during last 10 minutes

      this.timerService.setLastUserActivityTime();
  }
}

